function toast(text){
	if ($('.js-toast').css('display') != 'none') return;
	$('.js-toast').fadeIn(100).find('.ui-toast__text').text(text);
	setTimeout(function() {
		$('.js-toast').fadeOut(100);
	}, 2000);
}

$('input[type="radio"]').click(function(){
	var _parent = $(this).parents('li');
	_parent.addClass('is-active').siblings().removeClass('is-active');

	var _xxx = $(this).parents('.quiz-form');
    if ( _xxx.find('.is-active').length == 0 ) {
        _xxx.removeClass('done');
    } else {
        _xxx.addClass('done');
    }
});

$('input[type="checkbox"]').click(function(){
	var _parent = $(this).parents('li');
	if(this.checked){
		_parent.addClass('is-active');
	}else{
		_parent.removeClass('is-active');
	}
	
	var _xxx = $(this).parents('.quiz-form');
    if ( _xxx.find('.is-active').length == 0 ) {
        _xxx.removeClass('done');
    } else {
        _xxx.addClass('done');
    }
});

$('select').each(function() {
	checkSelect($(this));
});
$('body').on('change', 'select', function() {
	checkSelect($(this));
	$('select').blur();
});
function checkSelect(select) {
	var _target = select.attr('data-target');
	$('#'+_target).val( select.val() );
	if (select.val() && select.val() != '') {
		select.addClass('has-value');
	} else {
		select.removeClass('has-value');
	}
}

// 表单序列化
$.fn.serializeObject = function() {
	"use strict";
	var result = {};
	var extend = function(i, element) {
		var node = result[element.name];
		if ('undefined' !== typeof node && node !== null) {
			if ($.isArray(node)) {
				node.push(element.value);
			} else {
				result[element.name] = [node, element.value];
			}
		} else {
			result[element.name] = element.value;
		}
	};

	$.each(this.serializeArray(), extend);
	return result;
};
// 获取数组长度
function getJsonLength(json) {
	var jsonLength = 0;
	for (var i in json) {
		jsonLength++;
	}
	return jsonLength;
}
// 验证和过滤
var validateRegExp = {
	mobile:/^[1][0-9][0-9]{9}$/,
}
function ltrim(str, charlist) {
	charlist = !charlist ? ' \\s\u00A0' : (charlist + '').replace(/([[\]().?/*{}+$^:])/g, '$1');
	var re = new RegExp('^[' + charlist + ']+', 'g');
	return (str + '').replace(re, '');
}

// 表单验证 - 验证码按钮倒计时
var countdown = 60;
var code = '';
function getCodeCountdown(obj){
	if (countdown == 0) {
		obj.removeAttr('disabled').removeClass('is-disabled').text('获取验证码');
		countdown = 60;
		return;
	} else {
		obj.attr('disabled',true).addClass('is-disabled').text(+countdown+'s');
		countdown--;
	}
	setTimeout(function() {
		getCodeCountdown(obj)
	}, 1000)
}